<div class="d-flex flex-wrap container">
  <div class="w-100 d-flex align-items-center justify-content-center">
    <img
      src="./wealth-assets/svg/notify-alert.svg"
      alt="شما را از طریق پیامک باخبر خواهیم کرد"
    />
  </div>

  <p class="w-100 text-align-center mt-big st-7 text-onback-high">شما را از طریق پیامک باخبر خواهیم کرد</p>
  <p class="w-100 text-align-center mt-small bt-2 text-onback-low">
    داشتن حساب سجام و ثبت‌نام در کارگزاری «پاداش» برای سرمایه‌گذاری الزامی‌است. با پیش خرید، در کارگزاری نیز ثبت‌نام خواهید شد.
  </p>

  <div class="w-100 mt-big buttons-container">
    @for (button of buttons(); track button) {
      <ngx-button
        [style]="button.style === 'fill' ? 'fill' : 'tinted-on-elevated'"
        size="medium"
        [fullWidth]="true"
        [disabled]="button.disabled || button.loading"
        (clickHandler)="action(button.id)"
        [isLoading]="button.loading"
        [buttonId]="'IPO_NOTICE_' + button.id"
      >
        {{ button.label }}
      </ngx-button>
    }
  </div>
</div>
